// Constants & helpers for SuperAdmin page (extraccion para reducir tamaño del monolito).

export const BTYPE_LABELS = { agency: 'Agencia', developer: 'Desarrollador', independent: 'Independiente', franchise: 'Franquiciatario', owner: 'Propietario', car_dealer: 'Car-Dealer', platform: 'Plataforma' };
export const BTYPE_COLORS = { agency: 'bg-blue-500/10 text-blue-400 border-blue-500/20', developer: 'bg-violet-500/10 text-violet-400 border-violet-500/20', independent: 'bg-amber-500/10 text-amber-400 border-amber-500/20', franchise: 'bg-cyan-500/10 text-cyan-400 border-cyan-500/20', owner: 'bg-emerald-500/10 text-emerald-300 border-emerald-500/20', car_dealer: 'bg-red-500/10 text-red-300 border-red-500/20', platform: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' };

export const INDUSTRY_OPTIONS = [
  { value: 'real_estate', label: 'Inmobiliaria', icon: '🏢', desc: 'Propiedades, desarrollos y gestion de inventario', color: 'blue' },
  { value: 'automotive', label: 'Automotriz', icon: '🚗', desc: 'Agencias de autos, modelos y cotizador', color: 'red' },
  { value: 'education', label: 'Educacion', icon: '🎓', desc: 'Colegios, universidades y centros de capacitacion', color: 'violet' },
  { value: 'generic', label: 'Generico', icon: '⚡', desc: 'Cualquier tipo de negocio con leads y asesores', color: 'amber' },
];

export const INDUSTRY_SUBTYPES = {
  real_estate: [
    { value: 'agency', btype: 'agency', label: 'Agencia', desc: 'Inmobiliaria con equipo', modules: 'Propiedades, Leads, Oportunidades' },
    { value: 'developer', btype: 'developer', label: 'Desarrollador', desc: 'Constructor B2B', modules: 'Desarrollos, Leads, Oportunidades' },
    { value: 'independent', btype: 'independent', label: 'Independiente', desc: 'Promotor individual', modules: 'Propiedades, Leads' },
    { value: 'franchise', btype: 'franchise', label: 'Franquiciatario', desc: 'White label y acceso total', modules: 'Todos los modulos' },
    { value: 'owner', btype: 'owner', label: 'Propietario', desc: 'Una propiedad y leads limitados', modules: 'Propiedades, Leads' },
  ],
  automotive: [
    { value: 'car_dealer', btype: 'car_dealer', label: 'Car Dealer', desc: 'Agencia de autos', modules: 'Car-Dealer, Car Builder, Leads' },
  ],
  education: [
    { value: 'school', btype: 'agency', label: 'Colegio / Escuela', desc: 'Educacion basica y media', modules: 'Marcas, Productos y Servicios, Leads' },
    { value: 'university', btype: 'agency', label: 'Universidad', desc: 'Educacion superior', modules: 'Marcas, Productos y Servicios, Leads' },
    { value: 'training_center', btype: 'agency', label: 'Centro de Capacitacion', desc: 'Cursos y certificaciones', modules: 'Marcas, Productos y Servicios, Leads' },
  ],
  generic: [
    { value: 'generic', btype: 'agency', label: 'Generico', desc: 'Negocio con leads y asesores', modules: 'Marcas, Productos y Servicios, Leads' },
  ],
};

export const INDUSTRY_LABELS = { real_estate: '🏢 Inmobiliaria', automotive: '🚗 Automotriz', education: '🎓 Educacion', generic: '⚡ Generico' };
export const PLAN_LABELS = { trial: 'Prueba', basic: 'Basico', pro: 'Pro', enterprise: 'Empresa', free: 'Gratuito' };
export const PLAN_COLORS = { trial: 'text-amber-400 border-amber-500/20', basic: 'text-blue-400 border-blue-500/20', pro: 'text-violet-400 border-violet-500/20', enterprise: 'text-emerald-400 border-emerald-500/20', free: 'text-green-400 border-green-500/20' };

// SA4: el árbol vive en planCatalog. Re-export para no romper imports viejos.
export { PLAN_MODULE_OPTIONS, DEFAULT_PLAN_MODULES } from './planCatalog';

export const LICENSE_TYPE_OPTIONS = [
  { value: 'agency', label: 'Agencias' },
  { value: 'independent', label: 'Independientes' },
  { value: 'developer', label: 'Desarrolladores' },
  { value: 'franchise', label: 'Franquicias' },
  { value: 'owner', label: 'Owner' },
  { value: 'car-dealer', label: 'Car-Dealer' },
  { value: 'education', label: 'Educacion' },
  { value: 'generic', label: 'General' },
  { value: 'retail', label: 'Retail' },
];

export const CATALOG_INDUSTRIES = ['education', 'generic'];
export const CATALOG_LICENSE_TYPES = ['education', 'generic', 'retail'];

export const CATALOG_MODULE_PATCH = {
  products: true,
  brands: true,
  properties: false,
  developments: false,
  car_dealer: false,
  car_builder: false,
};

export function isCatalogIndustry(industry) {
  return CATALOG_INDUSTRIES.includes(String(industry || '').toLowerCase());
}

export function isCatalogPlan(plan) {
  if (!plan) return false;
  const keys = [
    plan.license_type, plan.target_audience, plan.industry,
    ...(Array.isArray(plan.visible_for_types) ? plan.visible_for_types : []),
  ].map((v) => String(v || '').toLowerCase());
  return keys.some((k) => CATALOG_LICENSE_TYPES.includes(k) || CATALOG_INDUSTRIES.includes(k));
}

/** Alta de cuenta: colegio/general ven planes de esa vertical, no los de inmobiliaria. */
export function planMatchesNewAccount(plan, { businessType = 'agency', industry = '' } = {}) {
  const vis = Array.isArray(plan?.visible_for_types) ? plan.visible_for_types : [];
  if (!vis.length) return !isCatalogIndustry(industry);
  const ind = String(industry || '').toLowerCase();
  if (isCatalogIndustry(ind)) {
    return vis.includes(ind)
      || String(plan.industry || '').toLowerCase() === ind
      || String(plan.target_audience || '').toLowerCase() === ind
      || String(plan.license_type || '').toLowerCase() === ind;
  }
  const bt = businessType || 'agency';
  return vis.includes(bt);
}

export function applyIndustryToPlanForm(form, industry, firstSub) {
  if (isCatalogIndustry(industry)) {
    return {
      industry,
      industry_subtype: firstSub?.value || '',
      license_type: industry,
      target_audience: industry,
      visible_for_types: [industry],
      included_modules: { ...(form.included_modules || {}), ...CATALOG_MODULE_PATCH },
    };
  }
  return {
    industry,
    industry_subtype: firstSub?.value || '',
    license_type: firstSub?.btype || form.license_type,
    target_audience: firstSub?.btype || form.target_audience,
  };
}

export const getPriceMatrix = (plan) => {
  const monthly = Number(plan?.price_matrix?.monthly ?? plan?.price ?? 0);
  return {
    monthly,
    quarterly: Number(plan?.price_matrix?.quarterly ?? monthly * 3),
    semiannual: Number(plan?.price_matrix?.semiannual ?? monthly * 6),
    annual: Number(plan?.price_matrix?.annual ?? monthly * 12),
  };
};
